import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

const boxWidth = 456
const boxHeight = 256
const margin = 16

export const Grid = styled(FocusNode)`
  font-size: 18px;
`
export const ScrollContainer = styled.div`
  position: relative;
  height: 808px;
  padding: 4px 0;
  width: 1920px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
  &:first-child {
    padding-left: 224px;
  }
`
export const Section = styled.div`
  float: left;
`

export const Row = styled.div`
  display: flex;
  clear: both;
  &:after {
    content: '';
    display: none;
    clear: both;
  }
`
export const GridBoxElem = styled(FocusNode)<{
  $width: number
  $height: number
}>`
  position: relative;
  float: left;
  margin-right: ${`${margin}px`};
  margin-bottom: ${`${margin}px`};
  text-align: center;
  line-height: 100px;
  // background: conic-gradient(
  //     from 120deg at 10% 50%,
  //     #ddd 0% 10%,
  //     #999 0% 110deg,
  //     rgba(255, 255, 255, 0.05) 111deg,
  //     rgba(255, 255, 255, 0.2)
  //   ),
  //   conic-gradient(
  //     from 125deg at 35% 35%,
  //     #ddd 0% 30deg,
  //     #999 30deg 110deg,
  //     rgba(255, 255, 255, 0.05) 110deg,
  //     rgba(255, 255, 255, 0.2)
  //   ),
  //   conic-gradient(
  //     from 130deg at 85% 30%,
  //     #ccc 0% 85deg,
  //     #999 0% 110deg,
  //     rgba(255, 255, 255, 0.05) 110deg,
  //     rgba(255, 255, 255, 0.2)
  //   ),
  //   conic-gradient(
  //     from 125deg at 60% 10%,
  //     #ddd 0% 30deg,
  //     #aaa 0% 90deg,
  //     #777 0% 110deg,
  //     rgba(255, 255, 255, 0.05) 110deg,
  //     rgba(255, 255, 255, 0.2)
  //   );
  background: ${(props) => props.theme.colors.homeGrid.background};
  width: ${({ $width }) => `${boxWidth * $width + margin * ($width - 1)}px`};
  height: ${({ $height }) =>
    `${boxHeight * $height + margin * ($height - 1)}px`};
  &.isFocusedLeaf {
    box-shadow: 0 0 0 4px
      ${(props) => props.theme.colors.homeGrid.focusedElem.border};
  }
`
